import { useLocation, useSearchParams } from 'react-router'

import { SearchParamKey } from '@app/store/appStore.types'
import useAppSessionStore from '@app/store/useAppSessionStore'

const useOriginDomain = () => {
    const { pathname } = useLocation()
    const [searchParams] = useSearchParams()
    const signupOriginDomain = useAppSessionStore((state) => state.searchParams.signup_origin_domain)
    const loginOriginDomain = useAppSessionStore((state) => state.searchParams.login_origin_domain)

    return pathname.startsWith('/sign-up')
        ? searchParams.get(SearchParamKey.SIGNUP_ORIGIN_DOMAIN) ?? signupOriginDomain
        : searchParams.get(SearchParamKey.LOGIN_ORIGIN_DOMAIN) ?? loginOriginDomain
}

export default useOriginDomain
